export const STORE_CLASSES = 'STORE_CLASSES';
export const STORE_CLASS_COURSES = 'STORE_CLASSES_SECTIONS';
export const STORE_CLASS_CONCEPTS = 'STORE_CLASSES_CONCEPTS';
export const STORE_CLASS_SUBJECTS = 'STORE_CLASS_SUBJECTS';
export const STORE_TEACHERS = 'STORE_TEACHERS';